window.addEventListener('load', () => {
  document.querySelectorAll('.questions__item').forEach((item) => {
    const hiddenBlock = item.querySelector('p');
    if (hiddenBlock) {
      if (hiddenBlock?.classList.contains('hidden')) {
        hiddenBlock.style.maxHeight = '0px';
      } else {
        hiddenBlock.style.maxHeight = hiddenBlock.scrollHeight + 'px';
      }
    }
  });
});
